import styled from "styled-components";

import {
  alignItemsCenter,
  alpha,
  circle,
  fileAcceptAnimation,
  fileRejectAnimation,
  flexCenter,
  flexColumn,
  flexSpBetween,
  pseudo,
  rem,
} from "@styles/Utilities.styled";


export const StyledEditModalContent = styled.div`
  ${flexColumn}

  .form-group {
    gap: 1rem;
  }

  .files-wrapper {
    margin-top: 2rem;
    font-size: ${rem(14)};

    .dropzone {
      ${flexCenter}
      height: ${rem(150)};
      padding: 1rem;
      background-color: var(--clr-gray-100);
      border: 1px dashed var(--clr-primary-700);
      border-radius: var(--border-radius-2);
      cursor: pointer;

      &.active {
        border: 2px dashed var(--clr-primary-400);
      }

      &.accept {
        background-color: var(--green-3);
        border-color: var(--green-8);
        animation: ${fileAcceptAnimation} 1s var(--ease-slow-start) forwards;
      }

      &.reject {
        background-color: ${alpha("var(--clr-rose)", 0.15)};
        border-color: ${alpha("var(--clr-rose)", 0.8)};
        animation: ${fileRejectAnimation} 0.1s ease-out 4 forwards;
      }

      .text-content {
        ${flexColumn}
        align-items: center;
        gap: 1rem;

        .p-wrapper {
          text-align: center;

          p:first-child {
            font-weight: 500;
          }
          p:last-child {
            font-size: ${rem(13)};
            color: var(--clr-gray-400);
          }
        }

        .svg-wrapper {
          ${flexCenter}
          ${circle(rem(55))}
          background-color: ${alpha("var(--clr-primary-400)", 0.1)};
        }
        svg {
          font-size: 1.75rem;
        }
      }
    }

    .uploaded-files {
      margin-top: 2rem;

      h4 {
        font-weight: 400;
      }

      .empty-label {
        color: var(--clr-gray-300);
        margin-top: 1rem;
      }

      ul {
        ${flexColumn}
        gap: 0.5rem;
        margin-top: 1rem;

        li {
          ${flexSpBetween}
          gap: 1rem;
          padding: 0.5rem 1rem;
          border: 1px solid var(--clr-gray-175);
          border-radius: var(--border-radius-2);

          .content {
            ${alignItemsCenter}
            gap: 0.5rem;

            a {
              line-height: 1.2;
              transition: color 0.2s;

              &:hover {
                color: var(--clr-primary-400);
              }
            }

            svg {
              font-size: 1.5rem;
            }
          }
        }
      }
    }

    .ScrollAreaRoot {
      position: relative;
      margin-top: 0.5rem;
      height: unset;

      &::before {
        ${pseudo}
        left: 0;
        bottom: -1px;
        width: 100%;
        background: linear-gradient(to top, var(--clr-white), rgb(0, 0, 0, 0));
      }

      &.previous-files {
        height: ${rem(318)};
      }

      &.uploaded-files {
        height: ${rem(130)};
      }

      &.previous-files,
      &.uploaded-files {
        &.show-gradient {
          ul {
            li {
              &:last-child {
                margin-bottom: 1rem;
              }
            }
          }

          &::before {
            height: ${rem(40)};
          }
        }
      }
    }

    .ScrollAreaViewport {
      padding-inline: 0;
      padding-bottom: 0;
    }
  }
`;
